import { apiCommand, unparsedTokenCommand } from "./index.jsx"
import { toastr } from "react-redux-toastr"
import * as strings from "../strings"
import * as utils from "../utils"
import _ from "lodash"
import download from "downloadjs"

export const getAllBillingOrders = () => async ( dispatch, getState ) => {
  const result = await apiCommand( dispatch, getState, "getAllBillingOrders" )

  if ( result.message === "OK" ) {
    dispatch( {
      type: "SET_BILLING_ORDERS",
      billingOrders: result.result,
    } )
  }

  return result
}


export const createBillingOrder = billingOrder => async ( dispatch, getState ) => {
  const result = await apiCommand( dispatch, getState, "addBillingOrder", billingOrder )

  if ( result.message === "OK" ) {
    if ( _.isArray( result.result ) ) {
      result.result.map( billingOrder => dispatch( {
        type: "ADD_BILLING_ORDER",
        billingOrder,
      } ) )
    } else {
      dispatch( {
        type: "ADD_BILLING_ORDER",
        billingOrder: result.result,
      } )
    }
  }

  return result
}


export const updateBillingOrder = billingOrder => async ( dispatch, getState ) => {
  const safeBillingOrder = _.omit(billingOrder, ["initialBillingOrderType"]);
  const result = await apiCommand( dispatch, getState, "updateBillingOrder", safeBillingOrder )

  if ( result.message === "OK" ) {
    dispatch( {
      type: "UPDATE_BILLING_ORDER",
      billingOrder: result.result,
    } )
  }

  return result
}

// export const billingOrderOtherExpensesReport = id => async ( dispatch, getState ) => {
//   const token = getState().auth.token
//   return await utils.downloadFile(token, "billingOrderOtherExpensesReport", {id}, "Outras_Despesas.xlsx")
// }


export const billingOrderExpensesReport = id => async ( dispatch, getState ) => {
  const token = getState().auth.token
  return await utils.downloadFile(token, "billingOrderExpensesReport", {id}, "Relatório.xlsx")
}

export const deleteBillingOrder = id => async ( dispatch, getState ) => {
  const result = await apiCommand( dispatch, getState, "deleteBillingOrder", { id } );

  if ( result.message === "OK" ) {
    dispatch( { type: "DELETE_BILLING_ORDER", id } );
  }

  return result;
}



// WEBPACK FOOTER //
// ./src/actions/billingOrders.jsx